import { BaseSerializer } from './base.serializer'
import { UserShiftSettings, UserShiftWorkDay } from 'models/user-shift-settings.model'

export class UserShiftWorkDaySerializer extends BaseSerializer<UserShiftWorkDay> {
  static SERIALIZABLE_ATTRIBUTES = [
    "id", "shiftBegin", "shiftEnd", "breakBegin", "breakEnd", "active", "day"
  ]

  static initializeObject(attributes: Object): UserShiftWorkDay {
    return new UserShiftWorkDay(attributes)
  }
}

export class UserShiftSettingsSerializer extends BaseSerializer<UserShiftSettings> {
  // модель => json параметры
  // не забудь добавить ключи из SERIALIZERS в SERIALIZABLE_ATTRIBUTES
  static SERIALIZABLE_ATTRIBUTES = ["id", "utcOffset", "workDays"]
  static SERIALIZERS = {
    workDays: UserShiftWorkDaySerializer
  }
  static SERIALIZE_RENAME_KEYS = {
    workDays: 'workDaysAttributes'
  }

  // json параметры => модель
  static DESERIALIZERS = {
    workDays: UserShiftWorkDaySerializer
  }
  static DESERIALIZE_RENAME_KEYS = {}

  static initializeObject(attributes: Object): UserShiftSettings {
    return new UserShiftSettings(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/user-shift-settings.serializer.ts